import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const userSingleCourseAssignmentsTableHeadings = [
	{ data: 'assignmentName', title: ls('Assignment Name') },
	{ data: 'approval', title: ls('Approval') },
	{ data: 'submittedOn', title: ls('Submitted On') }
];

const userSingleCourseAssignmentsTableData = function(courseID) {
	var tableData = [];

	return tableData;
};

export {
	userSingleCourseAssignmentsTableHeadings,
	userSingleCourseAssignmentsTableData
};
